export default __webpack_public_path__ + "static/media/DSC_0585.775380c5.webp";